import React, { useState } from 'react';
import { Avatar, Box, Container, Paper, Grow, Grid, Typography, Tabs, Tab, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { AUTH_ACTION } from '../../interface';
import { signin, signup } from '../../actions/auth';
import useStyles from './styles';
import Input from '../Auth/Input/Input';
import useCommonStyles from '../CommonStyle/commonStyle';
import { store } from '../../index';
import { useSelector } from 'react-redux';
import { colabProject } from '../../actions/projects';
import GoToTop from '../Functional/GoToTop';


const initialState = { name:'', email:'', company:'', project_name:'', message:'' };
type RootState = ReturnType<typeof store.getState>;


const CoCreationForm = () => {
    const { project, isLoading } = useSelector((state: RootState) => state.projects);
    initialState.project_name = project.title;
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const [requestForm, setRequestForm] = useState(initialState);
    const [signupStep, setSignupStep] = useState(0);
    const [next, setNext] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [isSignup, setIsSignup] = useState(false);


    const handleShowPassword = () => setShowPassword((prevShowPassword) => (!prevShowPassword));

    const handleNavigate = () => { }
    const handleSubmitRequest = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log(e);
        // dispatch(signin(requestForm, history));
        dispatch(colabProject(project._id, requestForm));
        history.push('/startup/dashboard');

        // if (next) {
        //     setSignupStep(signupStep + 1)
        // } else {
        //     setSignupStep(signupStep - 1)
        // }
        // console.log(form);

        // if (formName==='profileInfoForm'){
        //     signup
        // }
        // if (isSignup) {
        //     dispatch(signup(form, history));
        // } else {
        //     dispatch(signin(form, history));
        // }
    };


    //@ts-ignore
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setRequestForm({ ...requestForm, [e.target.name]: e.target.value });
    const handleNoChange = (e: React.ChangeEvent<HTMLInputElement>) => setRequestForm({ ...requestForm});

    const switchMode = () => {
        setIsSignup((prevIsSignup) => !prevIsSignup);
        setShowPassword(false);
    };

    return (
        <Container maxWidth="lg">
            <Paper className={classes.paper} elevation={3}>
                <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={3} className={classes.parentGridContainer}>
                    <Grid item xs={12} sm={12} md={6} className={classes.leftGrid}>
                        <div className={classes.leftGridTypographies}>
                            <Typography component={'span'} variant="h5" className={classes.motivationalTitle} >
                                共創申請<br />
                            </Typography>
                            <Typography component={'span'} variant="subtitle1" className={classes.smallTitle}>
                                <br /> <br />
                                共創申請の概要です。共創申請の概要です。共創申請の概要です。共創申請の概要です。共創申請の概要です。共創申請の概要です。<br /><br />

                                共創申請の概要です。共創申請の概要です。共創申請の概要です。<br /><br />

                                共創申請の概要です。共創申請の概要です。共創申請の概要です。共創申請の概要です。
                            </Typography >
                        </div>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={6} className={classes.rightGrid} >

                        <form name="profileInfoForm" className={classes.form} onSubmit={handleSubmitRequest}>
                            <Grid container spacing={2}>
                                <Input name="name" label="名前" handleChange={handleChange} type="text" value={requestForm.name} />
                                <Input name="company" label="所属" handleChange={handleChange} type="text" value={requestForm.company} />
                                <Input name="email" label="メールアドレス" handleChange={handleChange} type="email" value={requestForm.email} />
                                <Input name="project_name" label="プロジェクト名" handleChange={handleNoChange} type="text" value={requestForm.project_name} />
                                <Input name="message" label="共創申請メッセージ" handleChange={handleChange} type="text" rows={5} multiline value={requestForm.message} />

                                {/* <Input name="password" label="Password" handleChange={handleChange} type={showPassword ? 'text' : 'password'} handleShowPassword={handleShowPassword} />
                                <Input name="confirmPassword" label="Repeat Password" handleChange={handleChange} type={showRepeatPassword ? 'text' : 'password'} handleShowPassword={handleShowRepeatPassword} /> */}
                            </Grid>
                            {/* <Button type="submit" variant="contained" color="primary" className={classes.submit} onClick={() => setSignupStep(1)} > */}
                            <Grid container alignItems="center" justifyContent="flex-end" className={classes.buttonsGrid}>
                                {/* <Link to="/startup/signup" className={classes.signupBtn}>新規登録されていない方はこちら</Link> */}
                                {/* <Button type="submit" variant="contained" color="primary" className={classes.submit} onClick={() => setNext(true)} > */}
                                <Button type="submit" variant="contained" color="primary" className={classes.submit} >
                                    申請依頼
                                    {/* <ArrowForwardSharpIcon color="secondary"/> */}
                                    {/* {isSignup ? 'Sign Up' : 'Sign In'} */}
                                </Button>
                            </Grid>


                            {/* <Grid container justifyContent="flex-end">
                                <Grid item>
                                    <Link to="/signup" className={classes.signupBtn}>新規登録</Link>
                                </Grid>
                            </Grid> */}

                        </form>
                    </Grid>

                </Grid>
            </Paper>
            <GoToTop/>
        </Container>
    )
}

export default CoCreationForm;
// function useQuery() {
//     return new URLSearchParams(useLocation().search);
// }

// const signup1 = () => {

//     const classes = useStyles();
    // const commonClasses = useCommonStyles();


//     return (
//         <Grow in>
//             <Container maxWidth="lg">
//                 <Grid container direction="row" justifyContent="space-between" alignItems="stretch" spacing={3} className={classes.parentGridContainer}>
//                     <Grid item xs={9} sm={6} md={6} className={classes.leftGrid} align='center'>
//                         <Typography component={'span'} variant="h2" className={classes.motivationalTitle} >
//                             世界を<br />変えよう<br />みんなの力で<br />
//                         </Typography>
//                         <Typography component={'span'} variant="h6" className={classes.smallTitle}>
//                             <br /> <br /> Flare は、社会問題を解決したい学生と、 <br />それを支援する企業をマッチングするプラットフォームです。
//                         </Typography >

//                         <br />
//                         <Button className={classes.signupButton}>新規登録</Button>
//                         <Button className={classes.loginButton}>ログイン</Button>

//                     </Grid>
//                     <Grid container item xs={3} sm={6} md={6}>
//                         <image className={classes.topImage}></image>
//                     </Grid>

//                 </Grid>


//             </Container>
//             {/* <Footer /> */}
//         </Grow>
//     )
// };

// export default signup1;